"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = styled_components_1.default.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: auto;\n"], ["\n    margin: auto;\n"])));
var Icon = styled_components_1.default(SVG)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    path {\n        fill: ", ";\n    }\n"], ["\n    path {\n        fill: ",
    ";\n    }\n"])), function (_a) {
    var isDisabled = _a.isDisabled, theme = _a.theme;
    return isDisabled ? theme.colorControlIconDisabled : theme.colorControlIcon;
});
exports.SearchIcon = function (_a) {
    var _b = _a.disabled, disabled = _b === void 0 ? false : _b, rest = __rest(_a, ["disabled"]);
    return (react_1.default.createElement(Icon, __assign({}, rest, { viewBox: "0 0 16 16", width: "16px", height: "16px", isDisabled: disabled }),
        react_1.default.createElement("path", { d: "M16,14.586,10.885,9.471a6.012,6.012,0,1,0-1.414,1.414L14.586,16ZM6,10a4,4,0,1,1,4-4A4,4,0,0,1,6,10Z" })));
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=SearchIcon.js.map